import gsap from "gsap";
import Scrollbar, { ScrollbarPlugin } from "smooth-scrollbar";

class DisableScrollPlugin extends ScrollbarPlugin {
	static pluginName = "disableScroll";

	static defaultOptions = {
		direction: "",
	};

	transformDelta(delta) {
		if (this.options.direction) {
			delta[this.options.direction] = 0;
		}

		return { ...delta };
	}
}

// load the plugin
Scrollbar.use(DisableScrollPlugin);

class AnchorPlugin extends ScrollbarPlugin {
	static pluginName = "anchor";

	onHashChange = () => {
		this.jumpToHash(window.location.hash);
	};

	onClick = (event) => {
		const { target } = event;

		if (target.tagName !== "A") {
			return;
		}

		const hash = target.getAttribute("href");

		if (!hash || hash.charAt(0) !== "#") {
			return;
		}

		this.jumpToHash(hash);
	};

	jumpToHash = (hash) => {
		const { scrollbar } = this;

		if (!hash) {
			return;
		}

		// reset scrollTop
		scrollbar.containerEl.scrollTop = 0;

		scrollbar.scrollIntoView(document.querySelector(hash));
	};

	onInit() {
		this.jumpToHash(window.location.hash);

		window.addEventListener("hashchange", this.onHashChange);

		this.scrollbar.contentEl.addEventListener("click", this.onClick);
	}

	onDestory() {
		window.removeEventListener("hashchange", this.onHashChange);

		this.scrollbar.contentEl.removeEventListener("click", this.onClick);
	}
}

// usage
Scrollbar.use(AnchorPlugin);

const bar = document.querySelector(".loading__bar--inner");
const counter_number = document.querySelector(".loading__counter--number");
let c = 0;
let barinterval = setInterval(() => {
	bar.style.width = c + "%";
	counter_number.innerText = c + "%";
	c++;
	if (c === 101) {
		clearInterval(barinterval);
		
		// Create and add particles
		const particlesContainer = document.createElement('div');
		particlesContainer.className = 'loading__particles';
		document.querySelector('.loading__box').appendChild(particlesContainer);

		// Add fewer particles for better performance
		for (let i = 0; i < 12; i++) {
			const particle = document.createElement('div');
			particle.className = 'particle';
			particlesContainer.appendChild(particle);
		}

		// Initial loading animations
		gsap.to(".loading__bar", {
			duration: 0.5,
			rotate: "90deg",
			left: "1000%",
			ease: "power4.out"
		});

		gsap.to(".loading__text, .loading__counter", {
				duration: 0.3,
				opacity: 0,
				y: -20,
				stagger: 0.05
		});

		// Particle animations
		gsap.to(".particle", {
			duration: "random(1, 2)",
			x: "random(-50, 50)",
			y: "random(-50, 50)",
			rotation: "random(-180, 180)",
			scale: "random(0.5, 1.2)",
			opacity: 1,
			stagger: {
				amount: 0.4,
				from: "center"
			},
			ease: "power2.out"
		});

		// Create main timeline
		const mainTimeline = gsap.timeline({
			defaults: { ease: "power2.inOut" }
		});

		mainTimeline
			.to(".loading__box", {
				duration: 0.5,
				height: "500px",
				borderRadius: "50%",
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				backdropFilter: "blur(10px)",
			})
			.to(".loading__svg", {
				duration: 0.3,
				opacity: 1,
				scale: 1.5,
				ease: "back.out(1.7)"
			});

		// Single rotation animation
		const rotationTimeline = gsap.timeline({
			repeat: 0, // Just one rotation
			defaults: { ease: "power1.inOut" }
		});

		rotationTimeline
			.to(".loading__svg", {
				duration: 1.2,
				rotate: "360deg",
				scale: 1.2,
			})
			.to(".loading__svg", {
				duration: 0.5,
				scale: 0.8,
				ease: "power2.in"
			});

		// Finale (after 2 seconds - reduced from 3)
		setTimeout(() => {
			// Particle finale
			gsap.to(".particle", {
				duration: 0.8,
				scale: 0,
				opacity: 0,
				x: "random(-100, 100)",
				y: "random(-100, 100)",
				stagger: {
					amount: 0.3,
					from: "center"
				},
				ease: "back.in(1.7)"
			});

			const finaleTimeline = gsap.timeline({
				defaults: { ease: "power2.inOut" },
				onComplete: () => {
					document.querySelector('.loading').style.display = 'none';
				}
			});

			finaleTimeline
				.to(".loading__svg", {
					duration: 0.3,
					scale: 2,
					rotate: "+=180",
					ease: "back.in(1.7)"
				})
				.to(".loading__svg", {
					duration: 0.5,
					scale: 0,
					opacity: 0,
					ease: "back.in(1.7)"
				})
				.to(".loading__box", {
					duration: 0.5,
					scale: 0.5,
					opacity: 0,
					ease: "power4.inOut"
				})
				.to(".loading", {
					duration: 0.5,
					opacity: 0,
					zIndex: -1,
					background: "transparent"
				});

			// Show main content
			gsap.to("header", {
				duration: 0.5,
				top: "0",
				delay: 0.2
			});
			
			gsap.to(".socials", {
				duration: 0.5,
				bottom: "10rem",
				delay: 0.4
			});
			
			gsap.to(".scrollDown", {
				duration: 0.5,
				bottom: "3rem",
				delay: 0.6
			});

			// Initialize smooth scroll
			setTimeout(() => {
				let options = {
					damping: 0.1,
					alwaysShowTracks: true,
					plugins: {
						disableScroll: {
							direction: "x",
						},
					},
				};
				let SmoothScroll = Scrollbar.init(document.body, options);
				SmoothScroll.track.xAxis.element.remove();
				SmoothScroll.track.yAxis.element.remove();
			}, 500);
		}, 2000); // Reduced to 2 seconds
	}
}, 20);

document.querySelectorAll('.project').forEach(card => {
	card.addEventListener('mousemove', e => {
		const rect = card.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;

		const centerX = rect.width / 2;
		const centerY = rect.height / 2;

		const rotateX = (y - centerY) / 20;
		const rotateY = (centerX - x) / 20;

		card.style.setProperty('--rotateX', `${rotateX}deg`);
		card.style.setProperty('--rotateY', `${rotateY}deg`);
	});

	card.addEventListener('mouseleave', () => {
		card.style.setProperty('--rotateX', '0deg');
		card.style.setProperty('--rotateY', '0deg');
	});
});

// Add cursor interaction with blobs
document.addEventListener('mousemove', (e) => {
	const blobs = document.querySelectorAll('.blob');
	const mouseX = e.clientX;
	const mouseY = e.clientY;

	blobs.forEach((blob, index) => {
		const speed = (index + 1) * 0.2;
		const x = (mouseX - window.innerWidth / 2) * speed;
		const y = (mouseY - window.innerHeight / 2) * speed;
		
		blob.style.transform = `translate(${x * 0.1}px, ${y * 0.1}px) scale(${1 + speed * 0.1})`;
	});
});

// Optional: Add this for smoother blob animation on scroll
let lastScrollTop = 0;

window.addEventListener('scroll', () => {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	const blobs = document.querySelectorAll('.blob');
	
	const direction = scrollTop > lastScrollTop ? 1 : -1;
	
	blobs.forEach((blob, index) => {
		const speed = (index + 1) * 0.5;
		const y = (scrollTop - lastScrollTop) * speed * direction;
		
		blob.style.transform += `translateY(${y}px)`;
	});
	
	lastScrollTop = scrollTop;
});
